import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Button, Grid, Card, Box, Stack, Typography } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import { collection, doc, getDoc, getDocs, increment, limit, orderBy, query, setDoc, startAfter, where } from "firebase/firestore";
import { db, nowTimeStamp } from "../../firebase";
import Container from "../../assets/styles/Container";
import { useNavigate } from "react-router-dom";
import Moment from "react-moment";
import LoadingButton from "@mui/lab/LoadingButton";
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, Select } from "@mui/material";

let Available = 0;
let jobPosts = 0;

const JobListEdit = () => {
  const theme = useTheme();
  const { currentUser } = useAuth();
  const [keyId, setKeyId] = useState("");
  const [selectedJob, setSelectedJob] = useState({});
  const navigate = useNavigate();
  const [loadPage, setLoadPage] = useState(false);
  const [jobs, setJobs] = useState([]);
  const FetchJobs = ({ JobsPerPage }) => {
    const q = query(
      collection(db, "jobs"),
      where("websites", "array-contains", process.env.REACT_APP_WEBSITE),
      where("uid", "==", currentUser.uid),
      orderBy("createDate", "desc"),
      startAfter(keyId),
      limit(JobsPerPage)
    );
    getDocs(q).then((jobs) => {
      jobs.forEach((job) => {
        setJobs((old) => [...old, { id: job.id, ...job.data() }]);
        setKeyId(job.data().createDate);
      });
    });
  };

  const Deactive = async (item) => {
    await setDoc(doc(db, "jobs", item.id), { status: !item.status }, { merge: true }).then(() => {
      window.location.reload(false);
    });
  };

  const Renew = async (item) => {
    let time = item.expireDate.toDate();
    time.setDate(time.getDate() + 180);
    await setDoc(doc(db, "users", currentUser.uid), { jobPosts: increment(item.websites.length) }, { merge: true });
    await setDoc(doc(db, "jobs", item.id), { expireDate: time }, { merge: true }).then(() => {
      window.location.reload(false);
    });
  };

  const fetchPayments = async () => {
    const docRef = collection(db, "users", currentUser.uid, "payments");
    const postRef = doc(db, "users", currentUser.uid);
    const postAvailable = await getDoc(postRef);
    jobPosts = postAvailable.data().jobPosts ? postAvailable.data().jobPosts : 0;
    await getDocs(docRef).then((payments) => {
      payments.forEach((payment) => {
        if (payment.data().status === "succeeded") {
          Available += Number(payment.data().metadata.item);
        }
      });
      setLoadPage(true);
    });
  };

  useEffect(() => {
    fetchPayments();
    FetchJobs({ JobsPerPage: 10, keyId: "" });
  }, []);

  const [sortBy, setSortBy] = useState(2);
  const [showDialog, setShowDialog] = useState(false);

  const handleSortChange = (event) => {
    setSortBy(event.target.value);
  };

  return loadPage ? (
    <Box bgcolor={"alternate.main"}>
      <Container>
        <Card sx={{ p: { xs: 4, md: 4 } }}>
          <Box display={"flex"} flexDirection={{ xs: "column", sm: "row" }} flex={"1 1 100%"} justifyContent={{ sm: "space-between" }} alignItems={{ xs: "flex-start", sm: "center" }} marginBottom={4}>
            <Box marginBottom={{ xs: 2, sm: 0 }}>
              <Typography variant={"h6"} fontWeight={700}>
                Job ads
              </Typography>
              <Typography color={"text.secondary"}>Add new job ads or manage the existing ads</Typography>
            </Box>
            <Typography>you have {Available - jobPosts} credit(s)</Typography>
            <Button
              variant={"contained"}
              size="large"
              href="/post"
              startIcon={
                <Box component={"svg"} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" width={20} height={20}>
                  <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                </Box>
              }
            >
              Add new
            </Button>
          </Box>
          <Box>
            <FormControl sx={{ m: 1, minWidth: 220 }}>
              <Typography>Sort by</Typography>
              <Select
                value={sortBy}
                onChange={handleSortChange}
                sx={{
                  ".MuiSelect-select.MuiSelect-outlined": {
                    paddingY: "9px !important",
                  },
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.divider,
                  },
                }}
              >
                <MenuItem value={"expireDate"}>Expire Date</MenuItem>
                <MenuItem value={"createDate"}>Create Date</MenuItem>
                <MenuItem value={"title"}>Alphabet</MenuItem>
                <MenuItem value={"status"}>Status</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Grid container>
            {jobs
              .sort((a, b) => (a[sortBy] > b[sortBy] ? 1 : -1))
              .map((item, i) => (
                <Grid
                  item
                  xs={12}
                  key={item.id}
                  sx={{
                    borderTop: `1px solid ${theme.palette.divider}`,
                    backgroundColor: item.status ? "#F6FEEF" : "#FEF2EF",
                    padding: 3,
                  }}
                >
                  <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "flex-end", md: "center" }} paddingY={4}>
                    <Box width={1} marginBottom={{ xs: 4, md: 0 }}>
                      <Typography variant={"subtitle1"} fontWeight={700}>
                        {item.title}
                      </Typography>
                      <Typography color={"text.secondary"}>
                        <Moment unix format="YYYY/MM/DD">
                          {item.createDate.seconds}
                        </Moment>
                        {item.expireDate.seconds ? (
                          <>
                            {" - "}
                            <Moment unix format="YYYY/MM/DD" style={{ color: parseInt((item.expireDate.seconds - nowTimeStamp.seconds) / 86400) < 30 ? "red" : null }}>
                              {item.expireDate.seconds}
                            </Moment>
                          </>
                        ) : null}
                      </Typography>
                      <Box marginTop={1} display={"flex"} alignItems={"center"}>
                        <Box component={"svg"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width={24} height={24} marginRight={1}>
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </Box>
                        <Typography color={"text.secondary"}>{item.location ? item.location : "Canada"}</Typography>
                      </Box>
                    </Box>
                    <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "flex-end", md: "center" }} spacing={2}>
                      <LoadingButton
                        variant="outlined"
                        color={"error"}
                        size={"small"}
                        onClick={() => {
                          setShowDialog(true);
                          setSelectedJob(item);
                        }}
                        key={item.id}
                      >
                        Renew
                      </LoadingButton>
                      <Dialog fullWidth open={showDialog} onClose={() => setShowDialog(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">Are you sure you want to renew the post?</DialogTitle>
                        <DialogContent id="alert-dialog-description">
                          <Typography variant="h6">{selectedJob.title}</Typography>
                          <Typography variant="p">
                            By renewing the post, 180 days will be added to the post's expiry date, and {selectedJob.websites?.length} credit(s) will be deducted from your account
                          </Typography>
                          <Typography style={{ fontSize: 13 }}>The credit will be deducted from your account based on the number of websites that publish your post</Typography>
                        </DialogContent>
                        <DialogActions>
                          {Available - jobPosts > -1 ? <Button onClick={() => Renew(selectedJob)}>Renew</Button> : "You have not enough credit"}
                          <Button label="ra.action.cancel" onClick={() => setShowDialog(false)}>
                            Cancel
                          </Button>
                        </DialogActions>
                      </Dialog>
                      <LoadingButton
                        variant="outlined"
                        // color={item.status ? "success" : "error"}
                        size={"small"}
                        sx={{ width: 170 }}
                        onClick={() => Deactive(item)}
                      >
                        {item.status ? "click to deactivate" : "click to Active"}
                      </LoadingButton>
                      <Button
                        variant="outlined"
                        color="warning"
                        size={"small"}
                        onClick={() => {
                          navigate("/edit", {
                            state: item,
                          });
                        }}
                      >
                        Edit
                      </Button>
                      <Button variant="contained" size={"small"} target="_blank" href={`/jobs/${item.id}`}>
                        View
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
              ))}
            <Box margin={3} display={"flex"} alignItems={"center"}>
              <Button variant="contained" sx={{ margin: 2 }} onClick={() => FetchJobs({ JobsPerPage: 10 })}>
                Load 10 more
              </Button>
              <Button variant="contained" sx={{ margin: 2 }} onClick={() => FetchJobs({ JobsPerPage: 30 })}>
                Load 30 more
              </Button>
              <Button variant="contained" sx={{ margin: 2 }} onClick={() => FetchJobs({ JobsPerPage: 100 })}>
                Load 100 more
              </Button>
            </Box>
          </Grid>
        </Card>
      </Container>
    </Box>
  ) : (
    <></>
  );
};

export default JobListEdit;
